// CV10-020 차량 등록 관리 - 서버로 '신규' 데이터 보내기
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { incorrectToken } from '../../../../lib/utils/incorrectToken';
import * as Sentry from "@sentry/react";

interface uploadNewSingleDataProps {
  closeModal: () => void;
  resultData: any[];
  apartmentIdx: number;
  setDetectChangingData: Dispatch<SetStateAction<boolean>>;
}

export const uploadNewSingleData = async ({
  closeModal,
  resultData,
  apartmentIdx,
  setDetectChangingData,
}: uploadNewSingleDataProps) => {
  const token = sessionStorage.getItem('token');
  const apartmentRefIdx = sessionStorage.getItem('apartmentRefIdx');

  //console.log('uploadNewSingleData.tsx/주차개별등록-resultData: ', resultData);

  if (!apartmentIdx && Number(apartmentRefIdx) === 0) {
    return alert('먼저 단지를 선택해주세요');
  }

  if (resultData.CarNo.length <= 0) {
    return alert('차량 번호를 입력해주세요');
  }

  if (resultData.CarFlag === '') {
    return alert('등록 유형을 선택해주세요');
  }

  if (resultData.CarFlag === 'A' && resultData.Addr1 === '') {
    return alert('방문처 동을 입력해주세요');
  }

  if (resultData.CarFlag === 'A' && resultData.Addr2 === '') {
    return alert('방문처 호를 입력해주세요');
  }

  if (resultData.CarFlag === 'A' && resultData.OwnerPhone === '') {
    return alert('연락처룰 입력해주세요');
  }

  let currentApartmentRefIdx = '';
  if (Number(apartmentRefIdx) !== 0) {
    currentApartmentRefIdx = `${apartmentRefIdx}`;
  } else {
    currentApartmentRefIdx = `${apartmentIdx}`;
  }

  console.log('개별등록-currentApartmentRefIdx: ', currentApartmentRefIdx);
  console.log('개별등록-CarStartDate: ', resultData.CarStartDate);
  console.log('개별등록-ExpireDate: ', resultData.CarExpireDate);

  await axios({
    // https://dev.mmigroup.co.kr:8020/vehicle/cv10020/regcarmanage/1
    url: `${process.env.COMMON_URL}/vehicle/cv10020/regcarmanage/${currentApartmentRefIdx}`,
    method: 'post',
    headers: { tokenId: token },
    data: {
      Data: [
        {
          RegEmployeeNo: resultData.RegEmployeeNo ? resultData.RegEmployeeNo : '',
          Addr1: resultData.Addr1 ? resultData.Addr1 : '',
          Addr2: resultData.Addr2 ? resultData.Addr2 : '',
          OwnerName: resultData.OwnerName ? resultData.OwnerName : '',
          OwnerPhone: resultData.OwnerPhone ? resultData.OwnerPhone : '',
          CarNo: resultData.CarNo ? resultData.CarNo : '',
          CarFlag: resultData.CarFlag ? resultData.CarFlag : '',
          CarStartDate: resultData.CarStartDate ? resultData.CarStartDate : '',
          CarExpireDate: resultData.CarExpireDate ? resultData.CarExpireDate : '',
        },
      ],
    },
  }).then(res => {
    //console.log('📢url: ',`${process.env.COMMON_URL}/vehicle/cv10020/regcarmanage/${currentApartmentRefIdx}`);
    //console.log('👍uploadNewData.tsx-resultData: ', resultData);
    //console.log('👍res.data: ', res.data);
    try {
      closeModal();
      setDetectChangingData(true);
      if (res.data.ErrorCode === 0) {
        alert('차량 정보가 성공적으로 등록되었습니다');
      } else {
        Sentry.captureMessage(`Server Error : CV10-020 : ErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
        alert(`정상적으로 처리되지 않았습니다.\n\nErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
      }
      incorrectToken(res);
    } catch (e) {
      Sentry.captureException(e);
      console.error(e);
    }
  });
};
